/* unplugin-vue-components disabled */import { render } from "./login.vue?vue&type=template&id=23b3be22&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=23b3be22&lang=stylus&scoped=true"
import "./login.vue?vue&type=style&index=1&id=23b3be22&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b3be22"],['__file',"src/pages/login/login.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23b3be22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23b3be22', __exports__)) {
    api.reload('23b3be22', __exports__)
  }
  
  module.hot.accept("./login.vue?vue&type=template&id=23b3be22&scoped=true", () => {
    api.rerender('23b3be22', render)
  })

}


export default __exports__